import { defineStore } from 'pinia';
import CryptoJS from 'crypto-js';


function titleCase(str) {
    if(str){
        str = str.toLowerCase().split(' ');
        for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
        }
        return str.join(' ');
    }else
        return ''
}


const authStore = defineStore('xauth', {
        state: () => ({
            isLoggedIn: false,
            profile: {}
        }),

        getters: {
            decryptAuth: (state) => {
                let profile = {isLoggedIn: false, profile: null }
                try {
                    if (typeof state.profile === 'string' || state.profile instanceof String){
                        const _pString = CryptoJS.AES.decrypt(state.profile, process.env.VUE_APP_KEY).toString(CryptoJS.enc.Utf8)
                        if(_pString) profile = { isLoggedIn: state.isLoggedIn, profile: JSON.parse(_pString) }
                    }
                    return profile
                }catch(err){
                    return profile
                }
            }
        },

        actions: {
            logIn(user){
                this.isLoggedIn = true
                let profile = {...user, ...{ 
                        fname: titleCase(user.first_name),
                        lname: (user.last_name), 
                        mname: titleCase(user.middle_name),
                    }
                }
                
                if (!profile.is_kyc){
                     profile.is_identity_verified = user.is_identity_verified
                }

                const _pString = CryptoJS.AES.encrypt(JSON.stringify(profile), process.env.VUE_APP_KEY).toString()
                this.profile = _pString
            },

            updateInfo(param){
                let profile = this.decryptAuth.profile
                Object.entries(param).map( ([k,v]) => profile[k] = v )
                this.logIn(profile)
            },

            logOut(){
                this.isLoggedIn = false
                this.profile = {}
            },
        },
    });

export { authStore }
